import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {useSelector} from 'react-redux'
import {http} from 'hiya-common/src/utils/axios'
import {IProductsReq, IProductsResp} from '../reducers'

export const get_products_list_v2 = createAsyncThunk(
  '/live/pay/get_products_list_v2',
  async (productsReq: IProductsReq, store: any) => {
    const resp = await http.post<{data: IProductsResp}>(
      `/live/pay/get_products_list_v2`,
      {
        ...store.getState().env.deviceinfo,
        ...productsReq,
      }
    )

    return resp.data.data
  }
)

const initialState: {
  productListResp: IProductsResp
} = {
  productListResp: {} as IProductsResp,
}

export const WalletAdvancedExtraSlice = createSlice({
  name: 'WalletAdvancedExtra',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_products_list_v2.fulfilled, (state, action) => {
      const resp = action.payload
      Object.assign(state, {productListResp: {...resp}})
    })
  },
})

export default WalletAdvancedExtraSlice.reducer

export const WalletAdvancedExtraActions = WalletAdvancedExtraSlice.actions
export const useWalletAdvancedExtraState = () => {
  const data = useSelector((state) => {
    return state.WalletAdvancedExtra
  })
  return data
}
